webpackJsonp([75],{

/***/ 1262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_filters__ = __webpack_require__(278);



var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var baseUrl, code, _ref2, booking;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						baseUrl = '//pms.controlinn.com/api';
						code = this.$route.params.bookingCode;
						_context.next = 4;
						return this.$http.get(baseUrl + '/bookings/' + code);

					case 4:
						_ref2 = _context.sent;
						booking = _ref2.data;

						this.booking = booking.data;

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.loadData();
}

function guestNumber() {
	return this.booking.summary.booking.adults + this.booking.summary.booking.childrens;
}

function phoneData() {
	return this.booking.customer.data.phone || this.booking.customer.data.cellPhone || '---';
}

function channel() {
	var channelName = this.booking.channel ? this.booking.channel.data.name : '---';
	return channelName;
}

function data() {
	return {
		booking: {
			channel: {
				data: {}
			},
			customer: {
				data: {}
			},
			summary: {
				booking: {}
			}
		}
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'prepayment',
	computed: {
		guestNumber: guestNumber,
		phoneData: phoneData,
		channel: channel
	},
	created: created,
	data: data,
	filters: {
		parseDate: __WEBPACK_IMPORTED_MODULE_2__shared_filters__["b" /* parseDate */],
		round: __WEBPACK_IMPORTED_MODULE_2__shared_filters__["c" /* round */]
	},
	methods: {
		loadData: loadData
	}
});

/***/ }),

/***/ 1402:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".header-booking-data[data-v-53b328a3]{height:31px;position:absolute;right:20px;text-align:right;top:54px;width:calc(100% - 230px)}.header-booking-data-calendar[data-v-53b328a3]{margin:0!important;position:static;width:100%}.header-booking-data div[data-v-53b328a3]{padding-bottom:0!important;padding-top:0!important}.header-booking-data p[data-v-53b328a3]{color:#2e394b;font-family:San Francisco Display;font-size:10px;margin:0;text-transform:uppercase}.header-booking-data span[data-v-53b328a3]{color:#29abe2;font-family:San Francisco Display Medium;font-size:15px;text-transform:capitalize}.bar-data[data-v-53b328a3]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;-webkit-box-shadow:0 2px 5px 0 rgba(0,0,0,.1);box-shadow:0 2px 5px 0 rgba(0,0,0,.1);display:-webkit-box;display:-ms-flexbox;display:flex;height:48px;-ms-flex-pack:distribute;justify-content:space-around}.bar-data-item[data-v-53b328a3]{border-right:1px solid #e2e2e2;-webkit-box-flex:1;-ms-flex:1 auto;flex:1 auto}.bar-data-item.no-border[data-v-53b328a3],.bar-data-item[data-v-53b328a3]:last-of-type{border-right:0}.bar-data-item p[data-v-53b328a3]{color:#545e72;font-family:San Francisco Display Medium;font-size:14px;margin-bottom:0}.bar-data-item p span[data-v-53b328a3]{color:#818181;font-family:San Francisco Display;font-size:14px}.bar-data .bar-icon[data-v-53b328a3]{font-size:20px;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;width:20px}.label-title[data-v-53b328a3]{font-family:San Francisco Display Semi Bold}", "", {"version":3,"sources":["/opt/build/repo/src/clerkinn/calendar/Prepayment.vue"],"names":[],"mappings":"AACA,sCACE,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAkB,AAClB,SAAU,AACV,wBAA0B,CAC3B,AACD,+CACI,mBAAuB,AACvB,gBAAiB,AACjB,UAAY,CACf,AACD,0CACI,2BAA+B,AAC/B,uBAA4B,CAC/B,AACD,wCACI,cAAe,AACf,kCAAqC,AACrC,eAAgB,AAChB,SAAY,AACZ,wBAA0B,CAC7B,AACD,2CACI,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,yBAA2B,CAC9B,AACD,2BACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,sBAAwB,AACxB,8CAAmD,AAC3C,sCAA2C,AACnD,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,YAAa,AACb,yBAA0B,AACtB,4BAA8B,CACnC,AACD,gCACI,+BAAgC,AAChC,mBAAoB,AAChB,gBAAiB,AACb,WAAa,CACxB,AAID,uFACM,cAAkB,CACvB,AACD,kCACM,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,eAAmB,CACxB,AACD,uCACQ,cAAe,AACf,kCAAqC,AACrC,cAAgB,CACvB,AACD,qCACI,eAAgB,AAChB,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,UAAY,CACf,AACD,8BACE,2CAA+C,CAChD","file":"Prepayment.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.header-booking-data[data-v-53b328a3] {\n  height: 31px;\n  position: absolute;\n  right: 20px;\n  text-align: right;\n  top: 54px;\n  width: calc(100% - 230px);\n}\n.header-booking-data-calendar[data-v-53b328a3] {\n    margin: 0px !important;\n    position: static;\n    width: 100%;\n}\n.header-booking-data div[data-v-53b328a3] {\n    padding-bottom: 0px !important;\n    padding-top: 0px !important;\n}\n.header-booking-data p[data-v-53b328a3] {\n    color: #2e394b;\n    font-family: \"San Francisco Display\";\n    font-size: 10px;\n    margin: 0px;\n    text-transform: uppercase;\n}\n.header-booking-data span[data-v-53b328a3] {\n    color: #29abe2;\n    font-family: \"San Francisco Display Medium\";\n    font-size: 15px;\n    text-transform: capitalize;\n}\n.bar-data[data-v-53b328a3] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background-color: white;\n  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n          box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 48px;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.bar-data-item[data-v-53b328a3] {\n    border-right: 1px solid #e2e2e2;\n    -webkit-box-flex: 1;\n        -ms-flex: 1 auto;\n            flex: 1 auto;\n}\n.bar-data-item[data-v-53b328a3]:last-of-type {\n      border-right: 0px;\n}\n.bar-data-item.no-border[data-v-53b328a3] {\n      border-right: 0px;\n}\n.bar-data-item p[data-v-53b328a3] {\n      color: #545e72;\n      font-family: \"San Francisco Display Medium\";\n      font-size: 14px;\n      margin-bottom: 0px;\n}\n.bar-data-item p span[data-v-53b328a3] {\n        color: #818181;\n        font-family: \"San Francisco Display\";\n        font-size: 14px;\n}\n.bar-data .bar-icon[data-v-53b328a3] {\n    font-size: 20px;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n    width: 20px;\n}\n.label-title[data-v-53b328a3] {\n  font-family: \"San Francisco Display Semi Bold\";\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1487:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1402);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("03d7ed90", content, true);

/***/ }),

/***/ 1639:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('p', [_vm._v("Nombre")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t" + _vm._s(_vm.booking.customer.data.name) + "\n\t\t\t\t" + _vm._s(_vm.booking.customer.data.lastname) + "\n\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": "",
      "px-0": ""
    }
  }, [_c('p', [_vm._v("Celular")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.phoneData))])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Datos de reserva")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "bar-data"
  }, [_c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tLlegada:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.bookingStart)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tSalida:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.bookingEnd)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tNúmero de Noches:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.booking.numberNights))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tFecha de reserva:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.booking.bookingDate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tNúmero de Huéspedes:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.guestNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "bar-data-item no-border"
  }, [_c('p', [_vm._v("\n\t\t\t\t\t\tFuentes:\n\t\t\t\t\t\t"), _c('span', [_vm._v(_vm._s(_vm.channel))])])])])])], 1), _vm._v(" "), _c('router-view', {
    attrs: {
      "customer": _vm.booking.customer.data
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1487)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1262),
  /* template */
  __webpack_require__(1639),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-53b328a3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/75.64e01bb5fe9634f60929.js